import { jsx } from "react/jsx-runtime";
import { useRef, useMemo } from "react";
import { CloseReasons } from "../types/enums.js";
import { DropdownContext, DropdownActionsContext } from "./DropdownContext.js";
import "@mui/material";
import { createEvent } from "../../../hooks/useInternalControlled.js";
const ContextProvider = ({
  children,
  value,
  filter,
  onChange,
  onClose,
  mobileView,
  name,
  multi
}) => {
  const externalActionsRef = useRef({ onChange, handleClose: onClose });
  externalActionsRef.current.onChange = onChange, externalActionsRef.current.handleClose = onClose;
  const context = useMemo(() => ({
    value: (value == null ? void 0 : value.map((v) => {
      const { value: value2 } = v ?? {};
      return value2 || v;
    })) ?? [],
    filter,
    multi,
    mobileView
  }), [value, filter, multi, mobileView]), actions = useMemo(() => ({
    onChange: ({ value: value2, option }) => {
      var _a, _b;
      (_b = (_a = externalActionsRef.current).onChange) == null || _b.call(
        _a,
        createEvent({ value: value2, name }),
        option
      ), !multi && !mobileView && externalActionsRef.current.handleClose(CloseReasons.APPLY);
    },
    onClose: () => {
      externalActionsRef.current.handleClose(CloseReasons.CANCEL);
    },
    multi
  }), [mobileView, multi, name]);
  return /* @__PURE__ */ jsx(DropdownContext.Provider, { value: context, children: /* @__PURE__ */ jsx(DropdownActionsContext.Provider, { value: actions, children }) });
};
export {
  ContextProvider
};
//# sourceMappingURL=ContextProvider.js.map
